// ============================================================================
//  Registro de programas.
//  Para agregar un programa nuevo: creá su archivo (ej. programs/nuevo.js),
//  importalo acá y sumalo a PROGRAMAS y a ALIAS_PROGRAMA. Nada más cambia.
// ============================================================================
import domino from "./domino";
import eop from "./eop";
import mpel from "./mpel";

export const PROGRAMAS = {
  domino,
  eop,
  mpel,
};

export const PROGRAMA_POR_DEFECTO = "domino";

// Alias aceptados en la URL para cada programa.
export const ALIAS_PROGRAMA = {
  domino: "domino", "domino-mis-cuentas": "domino", dominomiscuentas: "domino", dmc: "domino",
  eop: "eop",
  mpel: "mpel",
};

// Devuelve los parámetros del query string, funcione con BrowserRouter
// (?x=1 en location.search) o con HashRouter (.../#/ruta?x=1 en location.hash).
function queryParams() {
  let s = window.location.search || "";
  if (!s && window.location.hash) {
    const qi = window.location.hash.indexOf("?");
    if (qi >= 0) s = window.location.hash.slice(qi);
  }
  return new URLSearchParams(s);
}

// Lee valores de campos que vengan por query string para prellenar el
// formulario. Toma cualquier parámetro con nombre tfa_* (ej: ?tfa_4675=abc)
// y también acepta el prefijo "prefill_" (ej: ?prefill_tfa_4675=abc).
// Devuelve un objeto { tfa_4675: "abc", ... } listo para mezclar en answers.
export function camposDesdeURL() {
  if (typeof window === "undefined") return {};
  const out = {};
  try {
    const qs = queryParams();
    for (const [k, v] of qs.entries()) {
      let campo = null;
      if (/^tfa_\w+$/.test(k)) campo = k;
      else if (/^prefill_tfa_\w+$/i.test(k)) campo = k.slice("prefill_".length);
      if (campo && v !== "") out[campo] = v;
    }
  } catch (e) { /* noop */ }
  return out;
}

// Devuelve { programa, tipo } leyendo la URL /chatbot/{programa}/{tipo}
// (o query strings ?programa= &tipo=). Cae en valores por defecto si falta algo.
export function detectarRuta() {
  const fallbackPrograma = PROGRAMA_POR_DEFECTO;
  const tipoDefault = (p) => PROGRAMAS[p]?.tipoPorDefecto
    || Object.keys(PROGRAMAS[p]?.tipos || { pre: 1 })[0];

  if (typeof window === "undefined") {
    return { programa: fallbackPrograma, tipo: tipoDefault(fallbackPrograma) };
  }

  const norm = (s) => (s || "").toLowerCase().trim();
  const resolverPrograma = (v) => ALIAS_PROGRAMA[norm(v)] || (PROGRAMAS[norm(v)] ? norm(v) : null);

  try {
    // 1) query string ?programa=eop&tipo=fin
    const qs = queryParams();
    let programa = resolverPrograma(qs.get("programa") || qs.get("prog") || qs.get("p"));
    let tipo = norm(qs.get("tipo") || qs.get("encuesta") || qs.get("t"));

    // 2) path /chatbot/{programa}/{tipo}
    if (!programa || !tipo) {
      // En HashRouter el path va en location.hash (ej: #/chatbot/eop/fin).
      let ruta = window.location.pathname;
      const h = window.location.hash || "";
      if (h.includes("/")) ruta += "/" + h.replace(/^#/, "").split("?")[0];
      const segs = ruta.toLowerCase().split("/").filter(Boolean);
      const idx = segs.indexOf("chatbot");
      const rest = idx >= 0 ? segs.slice(idx + 1) : segs;
      if (!programa && rest[0]) programa = resolverPrograma(rest[0]);
      if (!tipo && rest[1]) tipo = norm(rest[1]);
      // compatibilidad: /chatbot/pre  → programa por defecto
      if (!programa && rest[0] && PROGRAMAS[fallbackPrograma].tipos[norm(rest[0])]) {
        programa = fallbackPrograma; tipo = norm(rest[0]);
      }
    }

    if (!programa) programa = fallbackPrograma;
    if (!tipo || !PROGRAMAS[programa].tipos[tipo]) tipo = tipoDefault(programa);
    return { programa, tipo };
  } catch (e) {
    return { programa: fallbackPrograma, tipo: tipoDefault(fallbackPrograma) };
  }
}